import { IconProps } from "./types";
import React from "react";

export const TrashIcon = ({
  className,
  fill = "currentColor",
  width = 20,
  height = 20,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 20 20"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M4.37494 4.37207L5.15619 16.8721C5.1933 17.5943 5.71869 18.1221 6.40619 18.1221H13.5937C14.2839 18.1221 14.7995 17.5943 14.8437 16.8721L15.6249 4.37207"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.12506 4.37207H16.8751H3.12506Z" fill={fill} />
    <path
      d="M3.12506 4.37207H16.8751"
      stroke={fill}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M12.8125 6.87403L12.5 15.624M7.5 4.37403V2.81153C7.49964 2.68831 7.52364 2.56624 7.57063 2.45234C7.61761 2.33843 7.68666 2.23494 7.77378 2.14781C7.86091 2.06068 7.9644 1.99164 8.07831 1.94466C8.19221 1.89767 8.31428 1.87367 8.4375 1.87403H11.5625C11.6857 1.87367 11.8078 1.89767 11.9217 1.94466C12.0356 1.99164 12.1391 2.06068 12.2262 2.14781C12.3133 2.23494 12.3824 2.33843 12.4294 2.45234C12.4764 2.56624 12.5004 2.68831 12.5 2.81153V4.37403H7.5ZM10 6.87403V15.624V6.87403ZM7.1875 6.87403L7.5 15.624L7.1875 6.87403Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
